import React from "react";
import {PodigeeWidget} from "@src/interfaces";
import PodigeeItem from "@src/components/Podigee/PodigeeItem";

const Podigee = (props: PodigeeWidget) => (
  <PodigeeItem {...props} />
)
export default Podigee;
